import { autobind } from 'frontools/decorators/Autobind';
import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';

export default class Thumb extends AbstractDispatcher {

    private _elImg                : HTMLImageElement;
    private _img                  : string;
    private _hover                : string;
    private _isActive             : boolean                         = false;

    constructor(private _thumb: HTMLElement) {
        super();

        this._elImg = this._thumb.querySelector('img');
        this._img = this._elImg.getAttribute('src');

        // hover
        let dotIndex = this._img.lastIndexOf('.');
        this._hover = [this._img.slice(0, dotIndex), '_hover', this._img.slice(dotIndex)].join('');

        this._thumb.addEventListener('mouseover', this._onMouseEnter);
        this._thumb.addEventListener('mouseleave', this._onMouseLeave);
    };

    @autobind
    private _onMouseEnter(e: Event) {
        if (!this._isActive) {
            this._isActive = true;
            this._update(this._hover);
        }
    };


    @autobind
    private _onMouseLeave(e: Event) {
        if (this._isActive) {
            this._isActive = false;
            this._update(this._img);
        }
    };

    private _update(src: string) {
        let img = document.createElement('img');
        img.onload = function() {
            this._thumb.removeChild(this._elImg);
            this._thumb.appendChild(img);
            this._elImg = img;
        }.bind(this);

        img.src = src;
    }

    private _onLoad() {
        
    }


}